import React, { Component } from 'react';
import { string, func, bool, shape } from 'prop-types';
import cn from 'classnames';

import styles from './styles.module.scss';

class Tab extends Component {
  handleClick = (e) => {
    const { onClick, ...props } = this.props;
    const elementX = e.target.getBoundingClientRect().x;

    e.target?.parentElement?.scrollTo({ left: elementX, behavior: 'smooth' });

    onClick(props);
  };

  render() {
    const { className, active, disabled, text, icon, notFullWidth, buttonProps } = this.props;

    return (
      <button
        type="button"
        onClick={this.handleClick}
        disabled={disabled}
        className={cn('row center middle text-menu-link', styles.btnTab, className, {
          [styles.active]: active,
          'full-width': !notFullWidth
        })}
        {...buttonProps}>
        {icon?.default && (
          <i
            className={cn('m-right-2', styles.icon, {
              [icon.default]: !active,
              [icon.active]: active && icon.active,
              [styles.active]: active
            })}
          />
        )}
        {text}
      </button>
    );
  }
}

Tab.defaultProps = {
  className: ''
};

Tab.propTypes = {
  onClick: func.isRequired,
  active: bool,
  buttonProps: shape({}),
  className: string,
  disabled: bool,
  icon: shape({
    default: string.isRequired,
    active: string,
    disabled: string
  }),
  notFullWidth: bool,
  overrideClasses: bool,
  text: string
};

export default Tab;
